export type StoredAnonymousSession = {
  accessToken: string;
  sessionId: string;
};

const STORAGE_KEY_PREFIX = 'korint:anonymous-session:';

function getStorageKey(tenantId: string): string {
  return `${STORAGE_KEY_PREFIX}${tenantId}`;
}

export function getStoredSession(tenantId: string): StoredAnonymousSession | null {
  try {
    const raw = localStorage.getItem(getStorageKey(tenantId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.accessToken !== 'string' || typeof parsed?.sessionId !== 'string') {
      return null;
    }
    return parsed as StoredAnonymousSession;
  } catch {
    return null;
  }
}

export function setStoredSession(tenantId: string, session: StoredAnonymousSession): void {
  try {
    localStorage.setItem(getStorageKey(tenantId), JSON.stringify(session));
  } catch {
    // localStorage may be unavailable
  }
}

export function removeStoredSession(tenantId: string): void {
  try {
    localStorage.removeItem(getStorageKey(tenantId));
  } catch {
    // localStorage may be unavailable
  }
}
